var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38 0 0 5.38 0 12C0 18.62 5.38 24 12 24C18.62 24 24 18.62 24 12C24 5.38 18.62 0 12 0ZM18.46 14.26C18.46 15.55 17.49 16.56 15.99 16.84C14.67 17.06 13.34 17.17 12 17.17C10.67 17.17 9.33 17.06 8.02 16.83C6.48 16.5 5.54 15.54 5.54 14.25V9.73C5.54 8.46 6.48 7.48 8 7.16C10.65 6.72 13.34 6.72 15.99 7.16C17.5 7.44 18.47 8.45 18.47 9.73V14.25L18.46 14.26Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.11 11.72L10.88 9.77999C10.78 9.71999 10.65 9.71999 10.55 9.77999C10.45 9.83999 10.39 9.94999 10.39 10.06V13.94C10.39 14.06 10.45 14.17 10.55 14.24C10.6 14.27 10.66 14.28 10.71 14.28C10.77 14.28 10.83 14.27 10.88 14.23L14.11 12.29V12.27C14.21 12.21 14.26 12.1 14.26 11.99C14.26 11.88 14.2 11.77 14.11 11.71V11.72Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f5432ecef0979b3cccf521971b4cd449.svg";
export { ForwardRef as ReactComponent };